import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { Response } from 'src/app/services/models/response.model'
import { ImportMaster } from './models/pincard/importmaster.model';
import { StorageSearchRequest } from './models/pincard/storage.search.request.model';
import { SearchImportDetailRequest } from './models/pincard/pincards.searchImportdetail.request.model';
import { GetImportDetailRequest } from './models/pincard/getimportdetail.request.model';
import { Storage } from './models/pincard/storage.model';
import { CardStock } from './models/pincard/cardstock.model';

import { ImportDetail } from './models/pincard/importdetailmodel.model';
import { PinCodeRemoveRequest } from './models/pincard/pincode.remove.request.model';

@Injectable()
export class PinCardService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl = API_URI.pincard;
  }

  importPinCard(data: FormData): Observable<Response<any>> {
    return this.post(`/ImportPinCard`, data, {})
      .map(result => new Response<any>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  pinCodeImport(data: GetImportDetailRequest): Observable<Response<any>> {
    return this.post(`/PinCodeImport`, data, {})
      .map(result => new Response<any>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  removeImport(data: GetImportDetailRequest): Observable<Response<any>> {
    return this.post(`/RemoveImport`, data, {})
      .map(result => new Response<any>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  removePinCode(data: PinCodeRemoveRequest): Observable<Response<any>> {
    return this.post(`/RemovePinCode`, data, {})
      .map(result => new Response<any>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  getImportDetailsError(data: SearchImportDetailRequest): Observable<Response<any>> {
    return this.post(`/GetImportDetailsError`, data, {})
      .map(result => new Response<any>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  searchImportDetail(data: SearchImportDetailRequest): Observable<Response<any>> {
    return this.post(`/SearchImportDetail`, data, {})
      .map(result => new Response<any>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  searchImportMaster(providerId?: number, fromDate?: Date, toDate?: Date, status?: number, partnerID?: number): Observable<Response<ImportMaster[]>> {
    let url = `/searchImportMaster?fromDate=` + encodeURIComponent(fromDate.toJSON()) + '&toDate=' + encodeURIComponent(toDate.toJSON());
    if (providerId !== null)
      url = url + '&providerId=' + providerId;
    if (status !== null)
      url = url + '&status=' + status;
    if (partnerID !== null)
      url = url + '&partnerID=' + partnerID;
    return this.get(url)
      .map(result => new Response<ImportMaster[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  searchPinCode(data: string): Observable<Response<any[]>> {
    let url = `/SearchPinCode?searchData=` + encodeURIComponent(data);
    return this.get(url)
      .map(result => new Response<any[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  updateImportDetail(data: string): Observable<Response<any>> {
    let url = `/UpdateImportDetail?request=` + encodeURIComponent(data);
    return this.get(url)
      .map(result => new Response<any[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  updateImportDetails(data: any): Observable<Response<any>> {
    return this.post(`/UpdateImportDetails`, data, {})
      .map(result => new Response<any>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  searchPinCards(providerId?: number, fromDate?: Date, toDate?: Date, status?: number, partnerID?: number): Observable<Response<any>> {
    let url = `/SearchPinCards?fromDate=` + encodeURIComponent(fromDate.toJSON()) + '&toDate=' + encodeURIComponent(toDate.toJSON());
    if (providerId !== null)
      url = url + '&providerId=' + providerId;
    if (status !== null)
      url = url + '&status=' + status;
    if (partnerID !== null)
      url = url + '&partnerID=' + partnerID;
    return this.get(url)
      .map(result => new Response<any>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  CurrentStorage(data: StorageSearchRequest): Observable<Response<Storage[]>> {
    return this.post(`/CurrentStorage`, data, {})
      .map(result => new Response<Storage[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  searchStock(FromDate: Date, ToDate: Date): Observable<Response<CardStock[]>> {

    let url = `/StorageInOut`;
    return this.post(url, {
      FromDate,
      ToDate,
    })
      .map(result => new Response<CardStock[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }
}
